import { Domiciliation } from 'globals/models/Domiciliation'
import { useTranslation } from 'react-i18next'
import StateIcon from 'components/StateIcon'
import { AddMailConfirmationMessage, BackLink, CompanyName } from './styles'
import Mail from 'globals/models/Mail'

interface IProps {
  domiciliation: Domiciliation,
  mailId?: number,
  error?: string,
  onClearForm: () => void,
  onClose: () => void,
  selectedMail?: Mail | null
}

const AddMailConfirmation = (props: IProps) => {
  const { t } = useTranslation()
  const { domiciliation, mailId, error, onClearForm, onClose, selectedMail } = props

  return (
    <>
      <StateIcon type={error ? 'fail' : 'success'} />
      <CompanyName>{domiciliation.society.name}</CompanyName>

      { selectedMail ?
        <AddMailConfirmationMessage>
          Le courrier n°{selectedMail.id} a bien été modifié
        </AddMailConfirmationMessage> :
        <AddMailConfirmationMessage>
          {error || t('mails.add.confirmation', { id: mailId }) }
        </AddMailConfirmationMessage>
      }

      <BackLink onClick={onBackLinkClick(!!error, onClearForm, onClose)}>
        {error ? t('mails.add.back') : t('mails.add.add-more') }
      </BackLink>
    </>
  )
}

const onBackLinkClick = (isError: boolean, onClearForm: () => void, onClose: () => void) => () => {
  isError ?
    onClose() :
    onClearForm()
}

export default AddMailConfirmation
